import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FiX, FiUserPlus } from 'react-icons/fi';
import RegisterForm from './RegisterForm';

const FloatingButtons = () => {
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  // Show buttons when scrolling down
  useEffect(() => {
    const handleScroll = () => {
      setShowButtons(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    // WhatsApp API URL with predefined message
    const whatsappNumber = '+201044141237';
    const message = encodeURIComponent('Hi, I\'m interested in your real estate properties!');
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const toggleRegisterForm = () => {
    setShowRegisterForm(!showRegisterForm);
  };

  return (
    <div className="fixed right-0 bottom-0 z-30 flex flex-col gap-3 mr-4 mb-16">
      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className={`grid w-9 h-9 place-items-center rounded-full bg-green-500 text-white shadow shadow-green-500/60 transition-all duration-300 ${showButtons ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        aria-label="Contact us on WhatsApp"
      >
        <FaWhatsapp />
      </button>

      {/* Register Button */}
      <button
        onClick={toggleRegisterForm}
        className={`grid w-9 h-9 place-items-center rounded-full bg-primary text-white shadow shadow-primary/60 transition-all duration-300 ${showButtons ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        aria-label="Register Form"
      >
        {showRegisterForm ? <FiX /> : <FiUserPlus />}
      </button>

      {/* Register Form Modal */}
      {showRegisterForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-main-dark rounded-lg shadow-xl w-full max-w-md mx-4 relative overflow-hidden flex flex-col max-h-screen sm:max-h-[90vh] md:max-h-[85vh]">
            <RegisterForm onClose={toggleRegisterForm} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingButtons;